import { render, staticRenderFns } from "./OnlineUsersTable.vue?vue&type=template&id=298fb66c&"
import script from "./OnlineUsersTable.vue?vue&type=script&lang=js&"
export * from "./OnlineUsersTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports